<template>
  <div class="flex items-center bg-white bg-opacity-20">
    <vue-multiselect
      v-model="localeOptionSelected"
      label="label"
      :options="site.locales"
      :show-labels="false"
      :searchable="false"
    >
      <template slot="singleLabel" slot-scope="props">
        <div class="flex items-center">
          <img
            :src="`https://flagcdn.com/w40/${props.option.iso2.toLowerCase()}.png`"
            :srcset="`https://flagcdn.com/w80/${props.option.iso2.toLowerCase()}.png 2x`"
            :alt="props.option.label"
          />
          <span class="ml-2 text-white">{{ props.option.label }}</span>
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="flex">
          <img
            :src="`https://flagcdn.com/w40/${props.option.iso2.toLowerCase()}.png`"
            :srcset="`https://flagcdn.com/w80/${props.option.iso2.toLowerCase()}.png 2x`"
            :alt="props.option.label"
          />
          <span class="ml-2 text-wrap">{{ props.option.label }}</span>
        </div>
      </template>
    </vue-multiselect>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
  computed: {
    ...mapGetters(["site", "locale"]),
    localeOptionSelected: {
      get: function () {
        return this.site.locales.find((locale) => {
          return this.locale.id == locale.id
        })
      },
      set: function (newValue) {
        //console.log("SETTING NEW LOCALE", newValue)
        const newLocale = this.site.locales.find((el) => {
          return el.id == newValue.id
        })
        this.CHANGE_LOCALE(newLocale)
      }
    }
  },
  methods: {
    ...mapActions(["CHANGE_LOCALE"])
  },
  components: {
    "vue-multiselect": () => import("vue-multiselect")
  }
}
</script>

<style></style>
